import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '@global/store/store';
import { client } from '@src/global/Api';
import {
  CHECK_FOR_UNAVAILABLE_PRODUCTS,
  CHECK_FOR_UNAVAILABLE_PRODUCTS_TYPE,
} from '@src/global/requests/checkout';

export const isCartHasUnavailableProducts = createAsyncThunk<boolean>(
  'cart/isCartHasUnavailableProducts',
  async (_, { rejectWithValue, getState }) => {
    const state = getState() as RootState;

    try {
      const { data } = await client.query<CHECK_FOR_UNAVAILABLE_PRODUCTS_TYPE>({
        query: CHECK_FOR_UNAVAILABLE_PRODUCTS,
        variables: {
          cartId: state.cart.cartId,
          country: state.country.wPricingCountry,
        },
      });

      const { result } = data.wIsCartHasUnavailableProducts;
      return !!result.data.unavailableProducts.length;
    } catch {
      return rejectWithValue('SERVER ERROR');
    }
  }
);
